import { createOutlineIcon } from "../createIcon";

export const PowerOutlineIcon = createOutlineIcon(
  <>
    <path d="M12 11.5V4M6.708 6a8 8 0 1 0 10.583 0" />
  </>,
  "PowerOutlineIcon"
);
